import React from 'react';
import PropTypes from 'prop-types';
import AccountContentWrapper from '../Account/AccountContentWrapper';
import OrderByUrlParam from '../Account/OrderByUrlParam';
import './Page.css';

export default function AccountOrder(props) {
  return (
    <AccountContentWrapper
      locale={props.locale}
      setLocale={props.setLocale}
      services={props.services}
      dataStorage={props.dataStorage}
      setDataStorage={props.setDataStorage}
    >
      <OrderByUrlParam
        services={props.services}
        dataStorage={props.dataStorage}
        locale={props.locale}
      />
    </AccountContentWrapper>
  );
}

AccountOrder.propTypes = {
  locale: PropTypes.string.isRequired,
  setLocale: PropTypes.func.isRequired,
  services: PropTypes.objectOf(PropTypes.object).isRequired,
  dataStorage: PropTypes.objectOf(PropTypes.any).isRequired,
  setDataStorage: PropTypes.func.isRequired,
};
